export default __webpack_public_path__ + "static/media/logo-real.015e2a71.png";